import React, { useContext } from 'react';

import { ImportTestCasesStatusContext } from '@qality/common-components/src/lib/ImportTestCasesStatusProvider';
import { StorageOfUniqueServices } from '@qality/common-service';

import { ImportFailureView } from './ImportFailure.view';

export const ImportFailure = () => {
  // @ts-expect-error ImportTestCasesStatusContext is in plain JS
  const { importErrorObject } = useContext(ImportTestCasesStatusContext);

  const contactSupport = () => {
    window.open(plugin.feedbackUrl, '_blank');
  };

  const tryAgain = () => {
    StorageOfUniqueServices.get('AP').navigator.reload();
  };

  return (
    <ImportFailureView
      errorMessage={importErrorObject?.response?.data?.message}
      errorCode={importErrorObject?.response?.status}
      contactSupport={contactSupport}
      tryAgain={tryAgain}
    />
  );
};
